import { useEffect, useState } from 'react';
import type { AdminStore } from 'services/api/admin';
import { convertStoreScopesToStores } from '@knowledge/common/helpers/store';
import { getGroupByStores } from '@knowledge/common/cache/store';

export const useScopedStores = (storeScope?: General.StoreScope[]) => {
  const [stores, setStores] = useState<AdminStore[]>([]);
  useEffect(() => {
    if (!storeScope) return;
    getGroupByStores().then((res) => {
      setStores(convertStoreScopesToStores(storeScope, res));
    });
  }, [storeScope]);

  return stores;
};
